var getBasis = function getBasis(basis) {
  return function (_ref) {
    var theme = _ref.theme;

    if (typeof basis === "undefined") {
      return null;
    }

    if (typeof basis === "function") {
      return basis(theme);
    }

    return basis;
  };
};

export default getBasis;